var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.826,
    height: 11.221,
    viewBox: "0 0 11.826 11.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12494",
    "data-name": "Group 12494",
    transform: "translate(-1711.12 -390.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38435",
    "data-name": "Path 38435",
    d: "M1713.235,393.058a4.487,4.487,0,0,0-.3,1.619v1.337a6.562,6.562,0,0,1-1.394,4.339h10.983a6.562,6.562,0,0,1-1.394-4.339v-1.337a4.2,4.2,0,0,0-4.1-4.3,4,4,0,0,0-2.969,1.337Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38436",
    "data-name": "Path 38436",
    d: "M1713.235,393.058a4.487,4.487,0,0,0-.3,1.619v1.337a6.562,6.562,0,0,1-1.394,4.339h10.983a6.562,6.562,0,0,1-1.394-4.339v-1.337a4.2,4.2,0,0,0-4.1-4.3,4,4,0,0,0-2.969,1.337Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.389
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38437",
    "data-name": "Path 38437",
    d: "M1717.573,400.237a.635.635,0,1,1-1.087.01",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38438",
    "data-name": "Path 38438",
    d: "M1717.573,400.237a.635.635,0,1,1-1.087.01",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.389
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.e39fc49e548552e823ce10f2b533c327.svg";
export { ForwardRef as ReactComponent };